const BOOKMARKED_SEARCHES_LS = 'bookmarked_searches';

export default BOOKMARKED_SEARCHES_LS;
